import SubmissionsView from 'broker/components/SubmissionsView';
import { SubmissionViewMode } from 'broker/components/SubmissionsView/utils';

export default function HomePage() {
  return <SubmissionsView viewMode={SubmissionViewMode.General} />;
}
